/* eslint-disable react/jsx-props-no-spreading */
import { RadioBlock as ChromaRadioBlock } from '@iag-packages/chroma-react/lib/components';
import React from 'react';
import styled from 'styled-components';
import THEME from 'theme';

const RadioBlockWrapper = styled.div`
  .c-radio-block__label {
    img {
      vertical-align: middle;
    }
  }

  .c-radio-block__input + .c-radio-block__label {
    border-radius: 6px;
    border-width: thin;
    border-color: ${THEME.FIELD.BORDER.DEFAULT};
  }

  .c-radio-block__input:checked + .c-radio-block__label {
    background-color: transparent !important;
    border-color: ${THEME.FIELD.BORDER.VALID} !important;
    border-width: ${THEME.FIELD.BORDER.SELECTED};
  }
`;

// need optional as true or firefox complains
export const RadioBlock = ({ ...props }) => (
  <RadioBlockWrapper>
    <ChromaRadioBlock {...props} optional />
  </RadioBlockWrapper>
);

export default RadioBlock;
